import { useState } from "react";
import { toast } from "sonner";
import { Input } from "@/components/ui/input";
import { Switch } from "@/components/ui/switch";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Field, GradButton } from "@/components/erp";
import { SelectBox } from "@/components/Inputs";
import { errMsg } from "@/lib/api";

const FieldInput = ({ f, value, onChange, prefix }) => {
  const tid = `${prefix}-${f.k}`;
  if (f.type === "select") return <SelectBox testid={tid} value={value == null ? "" : String(value)} onChange={onChange} options={f.options} />;
  if (f.type === "switch") return <div className="h-10 flex items-center"><Switch data-testid={tid} checked={!!value} onCheckedChange={onChange} /></div>;
  if (f.type === "liste") return <textarea data-testid={tid} rows={4} placeholder={f.placeholder} className="w-full rounded-md bg-white/5 border border-white/15 p-2 text-sm" value={(value || []).join("\n")} onChange={(e) => onChange(e.target.value.split("\n"))} />;
  if (f.type === "coklu") return (
    <div className="flex flex-wrap gap-2" data-testid={tid}>{f.options.map((o) => {
      const sec = (value || []).includes(o.value);
      return <button type="button" key={o.value} data-testid={`${tid}-${o.value}`} onClick={() => onChange(sec ? value.filter((x) => x !== o.value) : [...(value || []), o.value])}
        className={`px-3 py-1.5 rounded-full text-xs border ${sec ? "bg-[var(--g1)] border-[var(--g1)] text-white font-semibold" : "border-white/15 text-muted-foreground"}`}>{o.label}</button>;
    })}</div>
  );
  return (
    <Input data-testid={tid} type={f.type || "text"} step="any" className="bg-white/5" placeholder={f.placeholder} value={value ?? ""}
      onChange={(e) => onChange(f.type === "number" ? (e.target.value === "" ? 0 : Number(e.target.value)) : e.target.value)} />
  );
};

export const FormDialog = ({ title, fields, initial, onSubmit, onClose, prefix }) => {
  const [form, setForm] = useState(initial);
  const [busy, setBusy] = useState(false);
  const save = async () => {
    setBusy(true);
    try {
      await onSubmit(form);
      onClose();
    } catch (e) {
      toast.error(errMsg(e));
    } finally {
      setBusy(false);
    }
  };
  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="glass max-w-lg" data-testid={`${prefix}-dialog`}>
        <DialogHeader><DialogTitle className="font-head">{title}</DialogTitle></DialogHeader>
        <div className="grid sm:grid-cols-2 gap-4">
          {fields.filter((f) => !f.goster || f.goster(form)).map((f) => (
            <Field key={f.k} label={f.label} className={f.wide ? "sm:col-span-2" : ""}>
              <FieldInput f={f} prefix={prefix} value={form[f.k]} onChange={(v) => setForm((s) => ({ ...s, [f.k]: v }))} />
            </Field>
          ))}
        </div>
        <div className="flex justify-end gap-2 mt-2">
          <button onClick={onClose} className="px-5 py-2 rounded-full border border-white/10 text-sm hover:bg-white/5" data-testid={`${prefix}-iptal`}>Vazgeç</button>
          <GradButton onClick={save} disabled={busy} data-testid={`${prefix}-kaydet`}>Kaydet</GradButton>
        </div>
      </DialogContent>
    </Dialog>
  );
};
